import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }: { theme: Theme }) => theme.fonts.gramatika};
  gap: 32px;

  & + p {
    margin-top: 12px;
  }
`;
